import isEqual from "react-fast-compare"
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"

import type { AppDispatch, RootState } from "./typings"

export const useAppDispatch = () => useDispatch<AppDispatch>()

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useShallowEqaulSelector = <TSelected>(selector: (state: RootState) => TSelected) =>
	useAppSelector(selector, shallowEqual)

export const useDeepEqualSelector = <TSelected>(selector: (state: RootState) => TSelected) =>
	useAppSelector(selector, isEqual)
